// extracted by mini-css-extract-plugin
export default {"wrapper":"EventCardCarousel-module__wrapper___3768E"};